<template>
  <div v-if="!firstPageInit">
    <div class="row menubar tabs">
      <button class="active">Onboarding</button>
      <button @click="$store.state.currentView = 'IntakesRedos'">Her-intakes</button>
      <button @click="$store.state.currentView = 'IntakesCompleted'">Afgeronde intakes</button>
      <button @click="$store.state.currentView = 'IntakesDeleted'">Geannuleerde intakes</button>
      <button @click="createIntake" style="float:right">
        <awesomeIcon icon="plus" /> Nieuwe intake
      </button>
    </div>
    <div class="row menubar" style="display: flex;justify-content: space-between">
      <button
        class="dropdown-button"
        @click="toggleFilters"
        :title="`Filters ${filters ? 'verbergen' : 'tonen'}`"
      >
        <awesomeIcon icon="filter"/>
      </button>
      <input
        type="text"
        v-model.lazy="search"
        placeholder="Zoeken"
        class="searchbar"
        title="Zoeken op port, intake, gebruiker, e-mail, telefoonnummer"
        v-show="!filters"
        style="flex:1"
        @keyup.enter="clearInputs('generalSearch')"
      />
      <button
        @click="clearInputs('generalSearch')"
        class="search-button"
        v-show="!filters"
      >
        <awesomeIcon icon="search"/>
      </button>
      <div class="dropdown nowrap multi-dropdown" style="float:right">
        <button class="dropdown-button" @click="brandDropdown = true">
          <awesomeIcon icon="sort" />
          Merk{{ selectedBrands.length > 1 ? 'en' : '' }} ({{ selectedBrands.length }})
        </button>
        <div
          class="dropdown-bg"
          v-if="brandDropdown"
          @click="
            brandDropdown = false;
            getIntakes(true);
          "
        />
        <ul class="dropdown-list" v-if="brandDropdown">
          <li
            class="dropdown-deselect"
            @click="selectedBrands = ['Alle merken']"
          >
            <span :class="selectedBrands.length ? '' : 'grey'">
              Alle ({{ selectedBrands.length }}) actieve verwijderen
            </span>
          </li>
          <li
            v-for="(brand, index) in intakeBrands"
            :key="index"
            @click="toggleBrand(brand)"
            :title="(selectedBrands.includes(brand))
                ? 'Verwijderen'
                : 'Toevoegen'
              "
          >
          <div class="dropdown-checkbox checkbox-green">
            <awesomeIcon :icon="selectedBrands.includes(brand)
                ? 'check-square'
                : 'fa-regular fa-square'
              "/>
          </div>
          <span :class="selectedBrands.includes(brand) ? 'checkbox-green' : ''">
            {{ brand }}
          </span>
          </li>
        </ul>
      </div>

      <inputDropdown
        :array="orders"
        v-model="order"
        :cb="generalDropdownCB"
      />
      <inputDropdown
        :array="groups"
        v-model="view"
        :cb="generalDropdownCB"
        :defaultIndex="6"
        align="right"
      />
      <inputDropdown
        v-if="view == 'Gestart' || view == 'Gebruiker'"
        :array="dates"
        v-model="curDropdownDate"
        :cb="dateDropdownCB"
        :scroll="true"
      />
    </div>

    <div class="filters menubar" ref="filters" :class="filters ? 'active' : ''">
      <div class="filters-inner">
        <div class="input">
          <span>ID</span>
          <input type="number" v-model.lazy="idInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Portefeuille ID</span>
          <input type="text" v-model.lazy="portInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Inleg (€)</span>
          <input type="number" v-model.lazy="investmentInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Voortgang (%)</span>
          <input type="number" v-model.lazy="progressInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Telefoonnummer</span>
          <input type="text" v-model.lazy="phoneInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Sinds</span>
          <input type="date" v-model.lazy="sinceInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
        <span>Adviseur</span>
        <inputSuggest
          :array="advisors"
          v-model="currentAdvisor"
          :clearable="true"
          clearedDisplayValue="Adviseur"
          :scroll="true"
          :defaultIndex="-1"
          :cb="generalDropdownCB"
          type="text"
          class="userIdInput"
          width="190px"
          ref="managerInput"
          :roles="[2, 7, 8, 9, 10]"
        />
      </div>
        <div class="input">
          <span>Beheerder</span>
          <inputSuggest
            type="text"
            class="userIdInput"
            width="190px"
            v-model="managerInput"
            :cb="getIntakes"
            ref="managerInput"
            :roles="[7, 8, 9, 10]"
          />
        </div>
        <div class="input">
          <span>Gebruiker</span>
          <inputSuggest
            type="text"
            class="userIdInput"
            width="190px"
            v-model="userInput"
            :cb="getIntakes"
            ref="userInput"
          />
        </div>
        <div class="triple-filter">
          <div class="triple-name">Aangemaakt door ATP</div>
          <div class="triple-filter-holder">
            <div
              v-for="(name) in atpTriple"
              :key="name"
              @click="connected = name;getIntakes(true)"
              :class="connected === name ? 'active' : ''"
            >
              {{ name }}
            </div>
          </div>
        </div>
        <div class="input buttons">
          <button @click="clearInputs()">
            Wissen
          </button>
          <button @click="getIntakes()">
            <awesomeIcon icon="sync"/>
          </button>
          <button @click="search = '';getIntakes(true)">
            <awesomeIcon icon="search"/>
          </button>
        </div>
      </div>
    </div>

    <div class="card" v-if="intakes !== null && intakes.length">
      <!-- Delete reason modal -->
      <modalWindow
        v-if="deleteReasonModal"
        @close="clearReasonInput();deleteSelected();busy=false;"
        width="600"
      >
        <div class="titlebar">Intake(s) verwijderen</div>
        <div
          class="form-notice"
        >
          <strong>Let op:</strong><br />
          U staat op het punt om 1 of meerdere intakes te verwijderen. Geef hieronder aan waarom u
          de gekozen intake(s) wil(t) verwijderen?
        </div>
        <form @submit.prevent class="inset">
          <select v-model="reason" ref="reason" placeholder="Reden van verwijderen"
          >
            <option value="Onjuist telefoonnummer">Onjuist telefoonnummer</option>
            <option value="Voicemail onbeantwoord">Voicemail onbeantwoord</option>
            <option value="Telefoon onbeantwoord" selected>Telefoon onbeantwoord</option>
            <option value="Whatsapp onbeantwoord">Whatsapp onbeantwoord</option>
            <option value="Gaat zelf beleggen">Gaat zelf beleggen</option>
            <option value="Kiest voor concurrent">Kiest voor concurrent</option>
            <option value="Kiest voor rente">Kiest voor rente</option>
            <option value="Aversie beleggen">Aversie beleggen</option>
            <option value="Wil beslissing uitstellen">Wil beslissing uitstellen</option>
            <option value="Kan risico niet dragen">Kan risico niet dragen</option>
            <option value="Wil geen telefonisch contact">Wil geen telefonisch contact</option>
            <option value="Administratieve fout">Administratieve fout</option>
            <option value="Betwiste aanvraag">Betwiste aanvraag</option>
            <option value="Bounced email">Bounced e-mail</option>
            <option value="Test account">Test account</option>
          </select>
          <select
            v-if="reason === 'Kiest voor concurrent'"
            v-model="reasonParty"
            ref="reasonParty"
            placeholder="Concurrent"
          >
            <option value="ABN">ABN</option>
            <option value="ASR">ASR</option>
            <option value="Axento">Axento</option>
            <option value="BLG">BLG</option>
            <option value="BeSmart">BeSmart</option>
            <option value="Brand new day">Brand new day</option>
            <option value="Bright">Bright</option>
            <option value="Centraalbeheer">Centraalbeheer</option>
            <option value="Dexxi">Dexxi</option>
            <option value="Evi Van Lanschot">Evi Van Lanschot</option>
            <option value="Fintessa">Fintessa</option>
            <option value="Fitvermogen">Fitvermogen</option>
            <option value="ING">ING</option>
            <option value="Index people">Index people</option>
            <option value="Jouw">Jouw</option>
            <option value="Knab">Knab</option>
            <option value="Meesman">Meesman</option>
            <option value="NNEK">NNEK</option>
            <option value="Nationale Nederlanden">Nationale Nederlanden</option>
            <option value="OAKK">OAKK</option>
            <option value="Ostrica">Ostrica</option>
            <option value="Rabobank">Rabobank</option>
            <option value="Reaal">Reaal</option>
            <option value="SNS">SNS</option>
            <option value="Semmie">Semmie</option>
            <option value="Van Lanschot">Van Lanschot</option>
            <option value="iBeleggen">iBeleggen</option>
            <option value="Anders">Anders</option>
          </select>
          <textarea
            v-if="reasonParty === 'Anders'"
            v-model="otherPartyReason"
            ref="otherPartyReason"
            placeholder="Omschrijf de concurrent"
          />
          <p
            class="msg"
            style="margin-bottom: 0px"
            v-if="
              deleteErrorText
              && (
                !reason
                || (
                  reason === 'Kiest voor concurrent'
                  && (!reasonParty || reasonParty === 'Anders' && !otherPartyReason)
                )
              )
            "
          >
            {{ deleteErrorText }}
          </p>
          <input type=submit @click="stopIntakeWithReason()" value="Verwijderen">
        </form>
      </modalWindow>
      <table width="100%">
        <thead class="table-legend">
          <tr>
            <th></th>
            <th># / Port</th>
            <th>Gebruiker / E-mail / Tel</th>
            <th>Merk / Inleg</th>
            <th>Adviseur / Beheerder</th>
            <th>Progress / Sinds</th>
            <th></th>
          </tr>
        </thead>
        <tr v-if="filter(checks).length > 0">
          <td colspan=10>
            <button @click="deleteSelected">
              Verwijder geselecteerden ({{ filter(checks).length }})
            </button>
          </td>
        </tr>
        <tr v-for="intake in intakes" :key="intake.id">
          <td>
            <button
              @click="checks[intake.id] = !checks[intake.id]"
              class="secondary" style="float:left;padding:0">
              <awesomeIcon :icon="!checks[intake.id] ? 'fa-regular fa-square' : 'check-square'"/>
            </button>
          </td>
          <td class="info">
            <span class="grey">#{{ intake.id }}</span>
            <awesomeIcon
              icon="bell"
              class="grey"
              v-if="
                intake.admin.beleggen
                && intake.client == intake.admin.beleggen.sales
                && !`${intake.email}`.match('@vmvb.nl|@doelbeleggen.nl|@oxby.nl|@beerstap.nl')
              "
              :title="
                'Intake aangemaakt vanuit bestaande account (' +
                intake.client + '/' + intake.admin.beleggen.sales + ')'
              "
            />
            <br />
            <template v-if="intake.port">
              {{ intake.port }}
            </template>
            <span v-else class="grey">-</span>
            <br />
            <template
              v-if="
                intake.admin
                && intake.admin.overwrite
              "
            >
              <awesomeIcon
                icon="question-circle"
                class="grey"
                :title="intake.admin.overwrite"
              />
            </template>
            <template
              v-if="
                intake.admin
                && view === 'Ingeleverd (plan)'
                && Number(intake.admin.showstoppersErrors) > 0
              "
            >
              <awesomeIcon
                icon="exclamation-circle"
                class="grey"
                :title="`Plan heeft nog ${intake.admin.showstoppersErrors} showstopper(s)`"
              />
            </template>
            <template
              v-if="
                view === 'Ingeleverd (plan)'
                && Number(intake.admin.blockersErrors) > 0
              "
            >
              <awesomeIcon
                icon="ban"
                class="grey"
                :title="`Plan heeft nog ${intake.admin.blockersErrors} blocker(s)`"
              />
            </template>
          </td>
          <td class="concat">
            <template
              v-if="
                intake.intake &&
                  intake.intake.persoonsData
                  && intake.intake.persoonsData[0]
                  && (intake.intake.persoonsData[0].voorletters
                  || intake.intake.persoonsData[0].achternaam)
              "
            >
              {{ intake.intake.persoonsData[0].voorletters }}
              {{ intake.intake.persoonsData[0].tussenvoegsel }}
              {{ intake.intake.persoonsData[0].achternaam }}
            </template>
            <span class="grey">{{ intake.client }}</span>
            <br />
            <span class="grey help" :title="intake.email">{{ intake.email }}</span>
            <br />
            <template
              v-if="
                intake.intake
                && intake.intake.persoonsData
                && intake.intake.persoonsData[0]
                && intake.intake.persoonsData[0].telefoonnummer
              "
            >
              {{
                intake.intake.persoonsData[0].telefoonnummer
                  .replace(/[^\d\+]/g, '').replace(/^\+/g, '00').replace(/[^\d]/g, '')
                  .replace(/^00/g, '+').replace(/^0/g, '+31')
              }}
            </template>
            <span v-else class="grey">-</span>
          </td>
          <td>
            <template v-if="intake.admin.beleggen && intake.admin.beleggen.brand">
              {{ intake.admin.beleggen.brand }}
            </template>
            <span v-else class="grey">-</span>
            <br />
            <template
              v-if="intake.intake && intake.intake.goalData && intake.intake.goalData.vermogen"
            >
              &euro;{{ formatPrice(intake.value) }}/&euro;{{
                formatPrice(Number(intake.intake.goalData.vermogen), true)
              }}
            </template>
            <span v-else class="grey">-</span>
            <br />
            <span
              v-if="intake.intake && intake.intake.goalData && intake.intake.goalData.type"
              class="concat grey info"
              :title="
                intake.intake.goalData.type.replace(/^\w/, (c) => c.toUpperCase())
                + ' ' + (intake.intake.goalData.box == 1 ? 'box 1' : '')
                + (filter(intake.intake.offers, (o) => o.selected && !o.deleted).length > 0
                  ? ' - Geselecteerde offertes ('
                  + filter(
                    intake.intake.offers,
                    (o) => o.selected && !o.deleted,
                  ).length + ')'
                  : '')
                + (filter(
                  intake.intake.offers,
                  (o) => intake.admin.offers
                    && intake.admin.offers[o.offerId]
                    && intake.admin.offers[o.offerId].approved
                    && !o.deleted,
                ).length > 0
                  ? ' - Berekende offertes ('
                  + filter(
                    intake.intake.offers,
                    (o) => intake.admin.offers
                      && intake.admin.offers[o.offerId]
                      && intake.admin.offers[o.offerId].approved
                      && !o.deleted,
                  ).length + ')'
                  : '')
                + (filter(
                  intake.intake.offers,
                  (o) => (!intake.admin.offers
                    || !intake.admin.offers[o.offerId]
                    || !intake.admin.offers[o.offerId].approved)
                    && !o.deleted,
                ).length > 0
                  ? ' - Niet berekende offertes ('
                  + filter(
                    intake.intake.offers,
                    (o) => (!intake.admin.offers
                      || !intake.admin.offers[o.offerId]
                      || !intake.admin.offers[o.offerId].approved)
                      && !o.deleted,
                  ).length + ')'
                  : '')
              "
            >
              <awesomeIcon
                v-if="filter(
                  intake.intake.offers,
                  (o) => o.selected && !o.deleted
                ).length > 0"
                icon="check-circle"
                class="grey"
                style="margin-right:2px"
              />
              <template v-else>
                <awesomeIcon
                  v-if="filter(
                    intake.intake.offers,
                    (o) => intake.admin.offers
                      && intake.admin.offers[o.offerId]
                      && intake.admin.offers[o.offerId].approved
                      && !o.deleted
                  ).length > 0"
                  icon="calculator"
                  class="grey"
                  style="margin-right:2px"
                />
                <awesomeIcon
                  v-if="filter(
                    intake.intake.offers,
                    (o) => (!intake.admin.offers
                      || !intake.admin.offers[o.offerId]
                      || !intake.admin.offers[o.offerId].approved
                    ) && !o.deleted
                  ).length > 0"
                  icon="bell"
                  class="grey"
                />
              </template>
              {{ intake.intake.goalData.type.replace(/^\w/, (c) => c.toUpperCase()) }}
              {{ intake.intake.goalData.box == 1 ? ' box 1' : '' }}
              <template
                v-if="filter(
                    intake.intake.offers,
                    (o) => o.selected && !o.deleted
                  ).length > 0
                "
              >
                <br />
                {{offerType(intake.intake.offers)}}
              </template>
            </span>
            <span v-else class="grey">-</span>
          </td>
          <td class="concat150">
            <span class="grey help" :title="intake.adviseur">{{ intake.adviseur }}</span>
            <br />
            <span class="grey help" :title="intake.manager">{{ intake.manager }}</span>
            <br />
            <template
              v-if="intake.intake && intake.intake.rekeningData && intake.intake.rekeningData.type"
            >
              {{ intake.intake.rekeningData.type }}
            </template>
            <span v-else class="grey">-</span>
          </td>
          <td
            class="info"
            :title="
              `${new Date(intake.extraStatus.date).toLocaleDateString()}: ${
                intake.extraStatus.text
              } ${intake.extraStatus.info ? '- ' + intake.extraStatus.info : ''}`
            "
          >
            <template v-if="intake.intake && intake.intake.totalFields">
              {{ formatPrice(intake.progress, true) }}%
            </template>
            <span class="grey" v-else>-</span>
            <awesomeIcon
              v-if="intake.intake.files > 0"
              icon="file"
              class="grey"
              title="Bestanden geupload"
            />
            <awesomeIcon
              v-if="
                intake.extraStatus.text
                && intake.extraStatus.text.substring(0, 5) === 'Adm. '
                && intake.extraStatus.text !== 'Adm. Rek. Open'
              "
              icon="exclamation-circle"
              class="grey"
            />
            <awesomeIcon
              v-else-if="intake.extraStatus.text"
              icon="check-circle"
              class="grey"
            />
            <awesomeIcon
              v-if="
                intake.intake
                && intake.intake.persoonsData
                && intake.intake.persoonsData[intake.intake.persoonsData.length-1]
                && intake.intake.persoonsData[intake.intake.persoonsData.length-1].bsn
              "
              icon="address-card"
              class="grey"
              title="Legitimatie ingevuld"
            />
            <br />
            <!-- controle date and user -->
            <span class="grey">
              <template
                v-if="intake.status_specific === 'Controle'">
                Controle aangevraagd op:<br />
                {{ localDate(intake.admin.intakeCheck.handedDate) }}
                {{ intake.admin.intakeCheck.handedDate
                  ? `(${ dayCalculate(intake.admin.intakeCheck.handedDate, true) })`
                  : "-"
                }}
                <awesomeIcon
                  icon="user"
                  class="grey"
                  :title="`door ${(intake.admin.intakeCheck.handedUser || '')}`"
                />
              </template>
            </span>

            <span class="grey">
              <template
                v-if="
                  intake.status_specific == 'Geenlead'
                  || intake.status_specific == 'Gestart'
                  || intake.status_specific == 'Gebruiker'
                  || intake.status_specific == 'Gebruiker (offerte maken)'
                  || intake.status_specific == 'Gebruiker (offerte klaar)'
                  || intake.status_specific == 'Gebruiker (offerte gekozen)'
                "
              >
                Aangemaakt op:<br />
                {{ localDate(intake.order_date) }}
                ({{dayCalculate(intake.order_date, true)}})
                <awesomeIcon
                  icon="user"
                  style="width:9px"
                  class="grey"
                  v-if="
                    find(users, { id: parseInt(intake.create_client) })
                    && intake.create_client !== intake.client
                  "
                  :title="'door ' + find(users, { id: parseInt(intake.create_client) }).email"
                />
              </template>
              <template
                v-if="
                  intake.status_specific == 'Ingeleverd'
                  || intake.status_specific == 'Ingeleverd (port)'
                "
              >
                Ingeleverd op:<br />
                {{ localDate(intake.order_date) }}
                {{ intake.order_date ? "(" + dayCalculate(intake.order_date, true) + ")" : "-" }}
                <awesomeIcon
                  icon="user"
                  class="grey"
                  v-if="
                    find(users, { id: parseInt(intake.send_client) })
                    && intake.send_client !== intake.client
                  "
                  :title="'door ' + find(users, { id: parseInt(intake.send_client) }).email"
                />
              </template>
              <template
                v-if="intake.status_specific == 'Ingeleverd (plan)'">
                CDD akkoord op:<br />
                {{ localDate(intake.order_date) }}
                {{ intake.order_date
                  ? "(" + dayCalculate(intake.order_date, true) + ")"
                  : "-"
                }}
                <awesomeIcon
                  icon="user"
                  class="grey"
                  :title="'door ' + intake.admin.cddStatus.user"
                />
              </template>
              <template
                v-if="intake.status_specific == 'Ingeleverd (CDD)'">
                CDD ingediend op:<br />
                {{ localDate(intake.order_date) }}
                {{ intake.order_date
                  ? "(" + dayCalculate(intake.order_date, true) + ")"
                  : "-"
                }}
                <awesomeIcon
                  icon="user"
                  class="grey"
                  :title="'door ' + intake.admin.cddStatus.handedUser"
                />
              </template>
              <template v-if="intake.status_specific == 'Geaccepteerd'">
                Geaccepteerd op:<br />
                {{ localDate(intake.order_date) }}
                {{ intake.order_date ? "(" + dayCalculate(intake.order_date, true) + ")" : "-" }}
                <awesomeIcon
                  icon="user"
                  class="grey"
                  v-if="find(users, { id: parseInt(intake.accept_client) })"
                  :title="'door ' + find(users, { id: parseInt(intake.accept_client) }).email"
                />
              </template>
              <template
                v-if="
                  intake.status_specific == 'Ondertekend'
                  || intake.status_specific == 'Ondertekend (PSK)'
                "
              >
                Ondertekend op:<br />
                {{ localDate(intake.order_date) }}
                {{ intake.order_date ? "(" + dayCalculate(intake.order_date, true) + ")" : "-" }}
                <awesomeIcon
                  icon="user"
                  class="grey"
                  v-if="
                    find(users, { id: parseInt(intake.sign_client) })
                    && intake.sign_client !== intake.client
                  "
                  :title="'door ' + find(users, { id: parseInt(intake.sign_client) }).email"
                />
              </template>
            </span>
          </td>
          <td>
            <button
              class="secondary"
              @click="doAction('view', intake)"
              style="float:right;padding:5px"
              title="Bekijken"
            >
              <awesomeIcon icon="search" />
            </button>
          </td>
        </tr>
        <tr>
          <th></th>
          <th colspan=6>
            Totaal: &euro;{{formatPrice(
              curGroupValue,
              true,
            )}},-
          </th>
        </tr>
      </table>

      <pagerElement
        v-model="currentPage"
        :records="totalResults"
        :resultsPerPage="maxPerPage"
      />
    </div>
    <div v-else-if="intakes !== null" class="noresults">
      <span>Geen resultaten</span>
    </div>
    <div v-else class="loader"/>
  </div>
  <div v-else class="loader"></div>
</template>

<script>
import {
  find, sumBy, findIndex, filter,
} from 'lodash-es';
import inputSuggest from './ui/inputSuggest';

export default {
  name: 'AdminIntakes',
  components: {
    inputSuggest,
  },
  data() {
    return {
      deleteErrorText: '',
      deleteReasonModal: false,
      reason: '',
      reasonParty: '',
      otherPartyReason: '',
      selectedIntakes: [],
      firstPageInit: true,
      filters: false,
      users: [],
      checks: {},
      busy: false,
      view: 'Ingeleverd (port)',
      order: 'orderDate',
      intakes: null,
      date: null,
      currentPage: 0,
      maxPerPage: 20,
      totalResults: null,
      currentIntake: null,
      role: this.$store.state.role,
      selectedBrands: ['Alle merken'],
      stateDropdown: false,
      dateDropdown: false,
      brandDropdown: false,
      groups: [],
      filteredGroups: [],
      orders: [
        {
          label: 'Dagen (D)',
          value: 'orderDate',
        },
        {
          label: 'Dagen (A)',
          value: 'orderDateAsc',
        },
        {
          label: 'Voortgang',
          value: 'todo',
        },
        {
          label: 'Portefeuille',
          value: 'port',
        },
        {
          label: 'Startbedrag',
          value: 'inleg',
        },
      ],
      intakeBrands: [
        'Alle merken',
        'Doelbeleggen',
        'OXBY',
        'VMVB',
        'BVS',
      ],
      connected: 'Beide',
      atpTriple: [
        'Beide',
        'Ja',
        'Nee',
      ],
      search: '',
      idInput: '',
      portInput: '',
      investmentInput: '',
      progressInput: '',
      phoneInput: '',
      sinceInput: '',
      userInput: '',
      managerInput: '',
      currentAdvisor: null,
      advisors: [],
      curGroupValue: null,
      curDropdownDate: '',
      updateCount: 0,
    };
  },
  computed: {
    dates() {
      const dates = [];
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      for (let i = 0; i < 31; i += 1) {
        dates[i] = {
          value: date.toLocaleDateString(),
        };
        date.setMonth(date.getMonth() - 1);
      }
      return dates;
    },
  },
  async created() {
    if (this.readCookie('intakesOrder')) {
      this.order = this.readCookie('intakesOrder');
    }

    if (this.readCookie('intakesFilterView')) {
      this.view = this.readCookie('intakesFilterView');
    }

    if (this.readCookie('intakesFilterId')) {
      this.idInput = this.readCookie('intakesFilterId');
    }

    if (this.readCookie('intakesFilterPort')) {
      this.portInput = this.readCookie('intakesFilterPort');
    }

    if (this.readCookie('intakesFilterBrands')) {
      this.selectedBrands = this.readCookie('intakesFilterBrands').split(',');
    }

    if (this.readCookie('intakesFilterValue')) {
      this.investmentInput = this.readCookie('intakesFilterValue');
    }

    if (this.readCookie('intakesFilterProgress')) {
      this.progressInput = this.readCookie('intakesFilterProgress');
    }

    if (this.readCookie('intakesFilterUser')) {
      this.userInput = this.readCookie('intakesFilterUser');
    }

    if (this.readCookie('intakesFilterAtp')) {
      this.connected = this.readCookie('intakesFilterAtp');
    }

    if (this.readCookie('intakesFilterPhone')) {
      this.phoneInput = this.readCookie('intakesFilterPhone');
    }

    if (this.readCookie('intakesFilterSince')) {
      this.sinceInput = this.readCookie('intakesFilterSince');
    }

    if (this.readCookie('intakesFilterAdvisor')) {
      this.currentAdvisor = parseInt(this.readCookie('intakesFilterAdvisor'), 10);
    }

    if (this.readCookie('intakesFilterManager')) {
      this.managerInput = this.readCookie('intakesFilterManager');
    }

    this.date = new Date();
    this.date.setMonth(this.date.getMonth() - 1);
    this.getAdvisors();
    this.getIntakes(true);
  },
  watch: {
    currentPage() {
      this.getIntakes();
    },
    date() {
      this.getIntakes();
    },
    intakes() {
      this.checks = {};
    },
  },
  methods: {
    filter,
    find,
    toggleBrand(brand) {
      if (brand === 'Alle merken') {
        this.selectedBrands = [brand];
        return;
      }
      if (this.selectedBrands.includes('Alle merken')) {
        this.selectedBrands.splice(this.selectedBrands.indexOf('Alle merken'), 1);
      }
      if (this.selectedBrands.includes(brand)) {
        this.selectedBrands.splice(this.selectedBrands.indexOf(brand), 1);
      } else {
        this.selectedBrands.push(brand);
      }

      if (this.selectedBrands.length === 0) {
        this.selectedBrands = ['Alle merken'];
      }
    },
    dateDropdownCB(item) {
      this.date = new Date(item.value);
    },
    generalDropdownCB() {
      this.currentPage = 0;
      this.getIntakes(true);
    },
    toggleFilters() {
      this.filters = !this.filters;

      if (this.filters) {
        if (this.search) {
          this.search = '';
          this.getIntakes(true);
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.filters.style.overflow = 'visible';
          }, 150);
        });
      } else {
        this.$refs.filters.style.overflow = '';
      }
    },
    formatDate(date) {
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    },
    clearInputs(origin) {
      if (origin !== 'generalSearch') {
        this.search = '';
        this.view = 'Ingeleverd (port)';
      }
      this.idInput = '';
      this.portInput = '';
      this.investmentInput = '';
      this.progressInput = '';
      this.phoneInput = '';
      this.sinceInput = '';
      this.connected = 'Beide';
      this.currentAdvisor = null;
      this.order = 'orderDate';
      this.selectedBrands = ['Alle merken'];
      this.intakes = null;
      this.date = null;
      this.$refs.managerInput.clear();
      this.$refs.userInput.clear();
      this.getIntakes(true);
    },
    stateDropdownCB() {
      this.currentPage = 0;
    },
    offerType(offers) {
      let typeOfOffer = '';
      let offerText = '';
      for (let i = 0; i < offers.length; i += 1) {
        if (offers[i].selected && !offers[i].deleted) {
          typeOfOffer = offers[i].offerType;
        }
      }
      if (typeOfOffer === '5') {
        offerText = 'Normaal';
      }
      if (typeOfOffer === '4') {
        offerText = 'Lijfrente';
      }
      if (typeOfOffer === '3') {
        offerText = 'Vaste uitkering';
      }
      if (typeOfOffer === '2') {
        offerText = 'Vaste looptijd';
      }
      if (typeOfOffer === '1') {
        offerText = 'Leefrente';
      }
      if (typeOfOffer === '0') {
        offerText = 'Normaal';
      }
      return offerText;
    },
    deleteSelected() {
      if (!this.busy) {
        this.$store.state.confirm.toggle({
          text: 'Weet u zeker dat u deze intakes wilt verwijderen?',
          confirmText: 'Verwijderen',
          cb: (confirmed) => {
            if (confirmed) {
              this.busy = true;
              this.doDeleteSelected();
            }
          },
        });
      }
    },
    doDeleteSelected() {
      if (Object.entries(this.checks).length > 0) {
        const id = Object.entries(this.checks)[0][0];
        const intake = find(this.intakes, { id: Number(id) });
        if (
          this.reason === ''
          && (intake.status === 'Bezig' || intake.status === 'Ingeleverd')
        ) {
          this.reason = 'Telefoon onbeantwoord';
          this.selectedIntakes = Object.keys(this.checks);
          this.deleteReasonModal = true;
          return;
        }
        if (this.checks[id]) {
          delete this.checks[id];
          this.sdk.deleteIntake(id, this.doDeleteSelected);
        } else {
          delete this.checks[id];
          this.doDeleteSelected();
        }
      } else {
        this.clearReasonInput();
        this.getIntakes();
      }
    },
    stopIntakeWithReason() {
      if (
        !this.reason
        || (this.reason === 'Kiest voor concurrent' && !this.reasonParty)
        || (this.reasonParty === 'Anders' && !this.otherPartyReason)
      ) {
        if (!this.reason) {
          this.deleteErrorText = 'Kies alsjeblieft een reden.';
        } else if (this.reason === 'Kiest voor concurrent' && !this.reasonParty) {
          this.deleteErrorText = 'KIes alsjeblieft een concurrent.';
        } else {
          this.deleteErrorText = 'Omschrijf alsjeblieft de concurrent.';
        }
      } else {
        this.updateCount = 0;
        for (let i = 0; i < this.selectedIntakes.length; i += 1) {
          const intake = find(this.intakes, { id: Number(this.selectedIntakes[i]) });
          intake.intake.delete = this.reason;
          if (this.reason === 'Kiest voor concurrent') {
            intake.intake.deleteParty = this.reasonParty === 'Anders' ? this.otherPartyReason : this.reasonParty;
          }
          this.sdk.updateIntake(
            this.selectedIntakes[i],
            JSON.stringify(intake.intake),
            () => {
              this.updateCount += 1;
              if (this.updateCount === this.selectedIntakes.length) {
                this.doDeleteSelected();
              }
            },
          );
        }
      }
    },
    clearReasonInput() {
      this.reason = '';
      this.reasonParty = '';
      this.otherPartyReason = '';
      this.deleteReasonModal = false;
    },
    dayCalculate(date, text = false, dateCompare = new Date()) {
      if (date) {
        const oneDay = 24 * 60 * 60 * 1000;
        // eslint-disable-next-line
        const days = Math.round(Math.abs(new Date(dateCompare).getTime() - new Date(date).getTime()) / oneDay);
        if (text) {
          return days + (days === 1 ? ' dag' : ' dagen');
        }
        return days;
      }
      return null;
    },
    localDate(date) {
      if (date) {
        return (new Date(date)).toLocaleDateString();
      }
      return null;
    },
    chooseGroup(group, value) {
      this.view = group;
      this.curGroupValue = value;
      this.getIntakes(true);
    },
    chooseOrder(group) {
      this.order = group;
      this.getIntakes(true);
    },
    doAction(action, intake) {
      if (action === 'view') {
        window.open(`?intake=${intake.id}`);
      } else if (action === 'delete') {
        this.$store.state.confirm.toggle({
          text: 'Weet u zeker dat u deze intake wilt verwijderen?',
          confirmText: 'Verwijderen',
          cb: (confirmed) => {
            if (confirmed) {
              this.sdk.deleteIntake(intake.id, this.getIntakes);
            }
          },
        });
      }
    },
    getGroups() {
      const tempGroups = [
        {
          label: 'Geen lead (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Geenlead',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Gestart (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Gestart',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Gebruiker (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Gebruiker',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
      ];
      if (this.selectedBrands.includes('Doelbeleggen')
        || this.selectedBrands.includes('OXBY')
        || this.selectedBrands.includes('Alle merken')) {
        tempGroups.push(
          {
            label: 'Gebruiker (offerte maken) (0 / 0)',
            rightLabel: '€ 0 / 0',
            value: 'Gebruiker (offerte maken)',
            totalValue: 0,
            totalValueFiltered: 0,
            totalRowsFiltered: 0,
          },
          {
            label: 'Gebruiker (offerte klaar) (0 / 0)',
            rightLabel: '€ 0 / 0',
            value: 'Gebruiker (offerte klaar)',
            totalValue: 0,
            totalValueFiltered: 0,
            totalRowsFiltered: 0,
          },
          {
            label: 'Gebruiker (offerte gekozen) (0 / 0)',
            rightLabel: '€ 0 / 0',
            value: 'Gebruiker (offerte gekozen)',
            totalValue: 0,
            totalValueFiltered: 0,
            totalRowsFiltered: 0,
          },
        );
      }
      tempGroups.push(
        {
          label: 'Controle (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Controle',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Ingeleverd (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Ingeleverd',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
      );
      tempGroups.push(
        {
          label: 'Ingeleverd (port) (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Ingeleverd (port)',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
      );
      tempGroups.push(
        {
          label: 'Ingeleverd (CDD) (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Ingeleverd (CDD)',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Ingeleverd (plan) (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Ingeleverd (plan)',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Geaccepteerd (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Geaccepteerd',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Ondertekend (PSK) (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Ondertekend (PSK)',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Ondertekend (0 / 0)',
          rightLabel: '€ 0 / 0',
          value: 'Ondertekend',
          totalValue: 0,
          totalValueFiltered: 0,
          totalRowsFiltered: 0,
        },
        {
          rightLabel: '0 onboarding(s) - totaal € 0 / 0',
        },
      );
      this.groups = tempGroups;

      let filterArray = [];
      if (this.search) {
        filterArray.push(`search contains ${this.search}`);
      }

      if (this.idInput) {
        filterArray.push(`id eq ${this.idInput}`);
      }

      if (this.portInput) {
        filterArray.push(`port startswith ${this.portInput.trim()}`);
      }

      if (!this.selectedBrands.includes('Alle merken') && this.selectedBrands.length !== 0) {
        filterArray.push(`brand in ${this.selectedBrands.join(',')}`);
      }

      if (this.investmentInput) {
        filterArray.push(`capital eqgt ${this.investmentInput}`);
      }

      if (this.progressInput) {
        filterArray.push(`progress eqgt ${this.progressInput}`);
      }

      if (this.userInput) {
        filterArray.push(`client eq ${this.userInput}`);
      }

      if (this.connected !== 'Beide') {
        filterArray.push(`connected eq ${this.connected === 'Ja'}`);
      }

      if (this.phoneInput) {
        filterArray.push(`phone contains ${this.phoneInput.trim()}`);
      }

      if (this.sinceInput) {
        filterArray.push(`since eq ${this.sinceInput}`);
      }

      if (this.currentAdvisor) {
        filterArray.push(`advisor eq ${this.currentAdvisor}`);
      }

      if (this.managerInput) {
        filterArray.push(`manager eq ${this.managerInput}`);
      }

      filterArray = filterArray.join(';');
      this.sdk.getIntakeGroups((response) => {
        for (let i = 0; i < response.data.length; i += 1) {
          const index = findIndex(this.groups, { value: response.data[i].status });
          if (index !== -1) {
            this.groups[index].label = `${response.data[i].status} (0 / ${response.data[i].totalRows})`;
            this.groups[index].rightLabel = `€ 0 / ${this.formatPrice(response.data[i].totalValue, true)}`;
            this.groups[index].value = response.data[i].status;
            this.groups[index].totalValue = response.data[i].totalValue;
            this.groups[index].totalRows = response.data[i].totalRows;
          }
        }
        this.sdk.getIntakeGroups((response2) => {
          for (let i = 0; i < response2.data.length; i += 1) {
            const index = findIndex(this.groups, { value: response2.data[i].status });
            this.groups[index].label = this.groups[index].label.replace(/\b0\b/, response2.data[i].totalRows);
            this.groups[index].rightLabel = this.groups[index].rightLabel.replace(/\b0\b/, this.formatPrice(response2.data[i].totalValue, true));
            this.groups[index].totalRowsFiltered = response2.data[i].totalRows;
            this.groups[index].totalValueFiltered = response2.data[i].totalValue;
          }

          if (find(this.groups, { value: this.view }).totalRowsFiltered === 0) {
            for (let i = 0; i < this.groups.length; i += 1) {
              if (this.groups[i].totalRowsFiltered > 0) {
                this.view = this.groups[i].value;
                this.getIntakes();
                break;
              }
            }
          }
          this.groups[this.groups.length - 1].rightLabel = `${
            this.formatPrice(sumBy(this.groups, (group) => group.totalRowsFiltered), true)
          } / ${
            this.formatPrice(sumBy(this.groups, (group) => group.totalRows), true)
          } onboarding(s) - totaal € ${
            this.formatPrice(sumBy(this.groups, (group) => group.totalValueFiltered), true)
          } / ${
            this.formatPrice(sumBy(this.groups, (group) => group.totalValue), true)
          }`;
        }, false, filterArray);
      }, false);
    },
    eraseCookie(name) {
      this.createCookie(name, '', -1);
    },
    getIntakes(newSearch) {
      this.intakes = null;
      let order = [];

      if (this.order === 'orderDateAsc') {
        order.push('date ASC');
      }

      if (this.order === 'orderDate') {
        order.push('date DESC');
      }

      if (this.order === 'todo') {
        order.push('progress DESC');
      }

      if (this.order === 'port') {
        order.push('port ASC');
      }

      if (this.order === 'inleg') {
        order.push('capital DESC');
      }

      this.createCookie('intakesOrder', this.order);
      order = order.join(';');
      let filterArray = [];
      filterArray.push(`status_specific eq ${this.view}`);
      this.createCookie('intakesFilterView', this.view);

      if (this.search) {
        filterArray.push(`search contains ${this.search}`);
        this.createCookie('intakesFilterSearch', this.search);
      } else {
        this.eraseCookie('intakesFilterSearch');
      }

      if (this.idInput) {
        filterArray.push(`id eq ${this.idInput}`);
        this.createCookie('intakesFilterId', this.idInput);
      } else {
        this.eraseCookie('intakesFilterId');
      }

      if (this.portInput) {
        filterArray.push(`port startswith ${this.portInput.trim()}`);
        this.createCookie('intakesFilterPort', this.portInput.trim());
      } else {
        this.eraseCookie('intakesFilterPort');
      }

      if (!this.selectedBrands.includes('Alle merken') && this.selectedBrands.length !== 0) {
        filterArray.push(`brand in ${this.selectedBrands.join(',')}`);
        this.createCookie('intakesFilterBrands', this.selectedBrands);
      } else {
        this.eraseCookie('intakesFilterBrands');
      }

      if (this.investmentInput) {
        filterArray.push(`capital eqgt ${this.investmentInput}`);
        this.createCookie('intakesFilterValue', this.investmentInput);
      } else {
        this.eraseCookie('intakesFilterValue');
      }

      if (this.progressInput) {
        filterArray.push(`progress eqgt ${this.progressInput}`);
        this.createCookie('intakesFilterProgress', this.progressInput);
      } else {
        this.eraseCookie('intakesFilterProgress');
      }

      if (this.connected !== 'Beide') {
        filterArray.push(`connected eq ${this.connected === 'Ja'}`);
        this.createCookie('intakesFilteratp', this.connected);
      } else {
        this.eraseCookie('intakesFilterAtp');
      }

      if (this.userInput) {
        filterArray.push(`client eq ${this.userInput}`);
        this.createCookie('intakesFilterUser', this.userInput);
      } else {
        this.eraseCookie('intakesFilterUser');
      }

      if (this.phoneInput) {
        filterArray.push(`phone contains ${this.phoneInput.trim()}`);
        this.createCookie('intakesFilterPhone', this.phoneInput);
      } else {
        this.eraseCookie('intakesFilterPhone');
      }

      if (this.sinceInput) {
        filterArray.push(`since eqgt ${this.sinceInput}`);
        this.createCookie('intakesFilterSince', this.sinceInput);
      } else {
        this.eraseCookie('intakesFilterSince');
      }

      if (this.currentAdvisor) {
        filterArray.push(`advisor eq ${this.currentAdvisor}`);
        this.createCookie('intakesFilterAdvisor', this.currentAdvisor);
      } else {
        this.eraseCookie('intakesFilterAdvisor');
      }

      if (this.managerInput) {
        filterArray.push(`manager eq ${this.managerInput}`);
        this.createCookie('intakesFilterManager', this.managerInput);
      } else {
        this.eraseCookie('intakesFilterManager');
      }

      filterArray = filterArray.join(';');
      if (newSearch) {
        this.currentPage = 0;
      }
      this.getGroups();
      this.sdk.getUsersQuick((userResponse) => {
        this.users = userResponse.data;
        this.sdk.getAdminIntakes((response) => {
          this.firstPageInit = false;
          if (response.status === 200) {
            for (let i = 0; i < response.data.results.length; i += 1) {
              try {
                response.data.results[i].intake = JSON.parse(response.data.results[i].intake || '{}');
              } catch (e) {
                // eslint-disable-next-line
                console.log(`Intake ${response.data[i].id} failed to parse intake`);
                response.data.results[i].intake = {};
                response.data.results[i].admin = {};
              }
              try {
                response.data.results[i].admin = JSON.parse(response.data.results[i].admin || '{}');
              } catch (e) {
                // eslint-disable-next-line
                console.log(`Intake ${response.data.results[i].id} failed to parse admin`);
                response.data.results[i].admin = {};
              }
              try {
                response.data.results[i].extraStatus = JSON.parse(response.data.results[i].admin.status || '{}');
              } catch (e) {
                response.data.results[i].extraStatus = {};
              }

              response
                .data
                .results[i]
                .progress = (Number(
                  response.data.results[i].intake.wrongFields,
                )
                / Math.max(Number(
                  response.data.results[i].intake.totalFields,
                ), 21)) * 100;

              if (Number.isNaN(response.data.results[i].progress)) {
                response.data.results[i].progress = 0;
              }

              response.data.results[i].adviseur = '-';
              response.data.results[i].manager = '-';
              if (response.data.results[i].admin.beleggen) {
                response.data.results[i].brand = response.data.results[i].admin.beleggen.brand;
                const tempAdv = find(this.users, {
                  id: parseInt(response.data.results[i].admin.beleggen.sales, 10),
                });
                if (tempAdv) {
                  response.data.results[i].adviseur = tempAdv.name;
                }
                const tempMan = find(this.users, {
                  id: parseInt(response.data.results[i].admin.beleggen.manager, 10),
                });
                if (tempMan) {
                  response.data.results[i].manager = tempMan.name;
                }
              }
              response.data.results[i].todo = 100 - response.data.results[i].progress;
              response.data.results[i].inleg = 0;
              if (response.data.results[i].intake.goalData) {
                response
                  .data
                  .results[i]
                  .inleg = -Number(
                    response.data.results[i].intake.goalData.vermogen,
                  );
              }
            }
            this.intakes = response.data.results;
            this.totalResults = response.data.totalRows;
            this.curGroupValue = find(this.groups, { value: this.view }).totalValue;
            this.busy = false;
          } else {
            this.sdk.logout();
            window.location.reload();
          }
        }, filterArray, order, this.currentPage, this.maxPerPage);
      });
    },
    createIntake() {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u een nieuwe intake wilt starten?',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.createIntake((response) => {
              window.open(`?intake=${response.data.intake}`);
              this.getIntakes();
            });
          }
        },
      });
    },
    getAdvisors() {
      let filterArray = [];
      filterArray.push('role eqgt 7');
      filterArray = filterArray.join(';');
      this.sdk.getUserIds((response) => {
        if (response.status === 200) {
          this.advisors = [];

          for (let i = 0; i < response.data.results.length; i += 1) {
            this.advisors.push({
              label: response.data.results[i].name,
              value: response.data.results[i].id,
            });
          }
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filterArray, 0, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.filters {
  width: 100%;
  height: 0;
  transition: height 0.15s;
  background-color: $color-highlight;
  border-radius: 0;
  overflow: hidden;
  &.active {
    height: 184px;
  }
  .filters-inner {
    width: 100%;
    height: 184px;
    padding: 0 2px 2px 0;
    box-sizing: border-box;
    .input {
      width: calc(100% / 5);
      height: 60px;
      padding: 4px 0 0 2px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      vertical-align: top;
      span {
        padding-left: 3px;
        font-weight: bold;
      }
      input {
        border-radius: 0;
        width: 100% !important;
        height: 36px;
        vertical-align: top;
        width: calc(calc(100% / 5) - 2px);
        &:focus {
          box-shadow: none;
        }
      }
      &.buttons {
        flex-direction: row;
        align-items: flex-end;
        float: right;
        button {
          width: calc(50% - 1px);
          height: 36px;
          border-radius: 0;
          background-color: rgba(0,0,0, 0.1);
          &:hover {
            background-color: rgba(0,0,0, 0.2);
          }
        }
      }
      .userIdInput {
        width: auto !important;
        display: inline-block;
        vertical-align: top;
      }
    }
    .triple-filter {
      width: calc(100% / 3);
      height: 60px;
      padding: 4px 0 0 2px;
      font-size: 13px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      .triple-name {
        padding-left: 3px;
        font-weight: bold;
      }
      .triple-filter-holder {
        overflow: hidden;
        height: 36px;
        width: 100%;
        cursor: pointer;
        div {
          width: calc(100% / 3);
          height: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.1);
          &:hover,
          &.active {
            background-color: rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
  }
}
.concat {
  max-width: 175px;
  display: inline-block;
}
.dropdown-list {
  top: 36px;
}
.info {
  svg {
    margin: 0px 2px;
    cursor: help;
  }
}
.help {
  cursor: help;
}
.dropdown-button,
.search-button {
  border-radius: 0;
  float: left;
}
// chrome fix
input[type=checkbox] {
  width: initial;
}
.searchbar {
  margin-left: 2px;
  &:focus {
    box-shadow: none;
  }
}
.filter-dropdown {
  padding: 10px;
}
.noresults {
  width: 100%;
  height: auto;
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
  }
}

.multi-dropdown {
  width: 120px;
  margin: 0;
  display: inline-block;
  vertical-align: top;
  width: auto !important;
  .checkbox-green {
    color: #59b300;
  }
  button {
    border-radius: 0;
    margin-left: 2px !important;
  }
  .dropdown-button {
    margin-left: 3px;
    width: auto;
    padding: 0 10px;
  }
  .dropdown-list {
    width: auto;
    right: 0;
    top: 36px;
    li {
      display: flex;
      align-items: center;
      padding-left: 15px;
      position: relative;
      user-select: none;
      .dropdown-checkbox {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        svg {
          font-size: 13px;
        }
      }
      span.logTypeId {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
